import { linkedInLogo } from '../../assets';

export const footerColumns = [
  {
    title: 'Products',
    items: [
      'Fund Tokenization',
      'Investor Onboarding',
      'Compliance Suite',
      'Secondary Trading',
    ],
    links: ['/sales/create-fund', '/sales/create-fund', '/sales/create-fund', '/sales/create-fund'],
  },
  {
    title: 'Company',
    items: ['FAQ', 'Contact', 'Careers'],
    links: [
      'https://docs.equitee.app',
      '/',
      'https://angel.co/company/fsmultichain/',
    ],
  },
  {
    title: 'Legal',
    items: ['Terms & Conditions', 'Privacy Policy'],
    links: [
      'https://www.equitee.app/terms-and-conditions',
      'https://www.equitee.app/privacy-policy',
    ],
  },
];

export const socialIcons = [
  {
    src: linkedInLogo,
    alt: 'LinkedIn',
    link: 'https://www.linkedin.com/company/equitee/',
  },
  // {
  //   src: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGNsYXNzPSJsdWNpZGUgbHVjaWRlLXR3aXR0ZXIiPjxwYXRoIGQ9Ik0yMiA0cy0uNyAyLjEtMiAzLjRjMS42IDEwLTkuNCAxNy4zLTE4IDExLjYgMi4yLjEgNC40LS42IDYtMkM0IDEzIDMgNy4xIDMgNy4xcy0zIDItMy0yYzAtMi40IDMtMyA1LTIgMC0uNS0yLTQtMi00czMuNy0xIDYgMmMwLTQuNCAxMC04IDEzIDIuOVoiLz48L3N2Zz4=',
  //   alt: 'Twitter',
  //   link: 'https://twitter.com/equitee',
  // },
  // {
  //   src: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGNsYXNzPSJsdWNpZGUgbHVjaWRlLXRlbGVncmFtIj48cGF0aCBkPSJNMTEgMTUsMTcgMTAiLz48cGF0aCBkPSJNNi40MDQgOEMyMS4xNTIgMy4wMDQgMTUuNDM5LTEuMDkgMTQgMy43MjIiLz48cGF0aCBkPSJtMTQuNDE4IDMuNzQ1IDAuNTgyIDcuMyBjLjI0OCAzLjExIS00LjM4IDUuOTQtOS41NSA1Ljk0QTguMDQgOC4wNCAwIDAgMSAyIDE2Yy4xNy0uNC41My0uODUuOTgtMS4yNCIvPjwvc3ZnPg==',
  //   alt: 'Telegram',
  //   link: 'https://t.me/equitee',
  // }
];